export default {
  state: {
    searchResultsList: [],
    searchKBResultsList: [],
    searchTotal: 0
  },
  mutations: {
    setSearchResultsList: (state, { coursesData, total, kbData }) => {
      state.searchResultsList = coursesData
      state.searchKBResultsList = kbData
      state.searchTotal = total
    }
  },
  actions: {}
}
